import RatioBar from "@/elements/RatioBar/RatioBar";
import { useAxios } from "@/hooks/useAxios";

function StocksUpDown({ title }) {
    const { data: datas, loading } = useAxios(`/resources/stock-details/indices-up-down`);

    const data =
        datas?.advanceDeclineData?.filter(
            (f) => f.title.replaceAll(" ", "")?.toLowerCase() === title?.replaceAll(" ", "")?.toLowerCase()
        )?.[0] ?? null;

    if (!data) return null;
    return (
        <div className="border border-[#E5E5E5] rounded-2xl my-4 mx-4 p-6 bg-white resize-none">
            <div className="text-base font-semibold whitespace-nowrap mb-6">Stocks Up or Down</div>
            <RatioBar percent={(data?.advances * 100) / (data?.advances + data?.declines)} className="w-full " />
            <div className="flex flex-row justify-between font-Inter mt-3">
                <div className="text-xs font-semibold">{data?.advances}</div>
                <div className="text-xs font-semibold">{data?.declines}</div>
            </div>
        </div>
    );
}

export default StocksUpDown;
